import Vue from 'vue'
import dayjs from 'dayjs'


export const dateToDayMonthYear = (date) => {
  return dayjs(date).format('ddd DD MMM YYYY')
}

export const dateToDayMonthYearTime = (date) => {
  return dayjs(date).format('ddd DD MMM YYYY HH:mm')
}

Vue.filter('secToMin', function (secs) {
  return Math.round(secs / 60)
})


Vue.filter('dateToDayMonthYear', function (date) {
  return dateToDayMonthYear(date)
})


